import { render, staticRenderFns } from "./OrdersFBMShow.vue?vue&type=template&id=09bf1cfc&scoped=true"
import script from "./OrdersFBMShow.vue?vue&type=script&lang=js"
export * from "./OrdersFBMShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bf1cfc",
  null
  
)

export default component.exports